import { Dispatch, SetStateAction, useState } from 'react';

export type CashDataItemType<T> = { [key: string]: ValueType<T> };
export type GetValueType<T> = (key: string) => T | null;
export type ValueType<T> = T | [T, T] | null;
export type ValueTypes = string | number | Date | boolean | null;

type useGridFiltersType = (
	initValue?: CashDataItemType<ValueTypes>,
) => [
	CashDataItemType<ValueTypes>,
	(key: string) => ValueType<ValueTypes>,
	(key: string, value: ValueType<ValueTypes>) => void,
	() => void,
	Dispatch<SetStateAction<CashDataItemType<ValueTypes>>>,
];

/**
 *
 * @param cashKey
 * @param initialValue
 */
const useGridFilters: useGridFiltersType = (initValue = {}) => {
	const [data, setData] = useState<CashDataItemType<ValueTypes>>(initValue);

	const getValue: GetValueType<ValueType<ValueTypes>> = (key: string) => {
		return data[key] ?? null;
	};

	const setValue = (key: string, value: ValueType<ValueTypes>) => {
		setData((prev: any) => {
			return {
				...prev,
				[key]: value,
			};
		});
	};

	const reset = () => {
		return setData({});
	};

	return [data, getValue, setValue, reset, setData];
};

export default useGridFilters;
